import React from "react";

const Read = () => {
  return (
    <>

       {/* HERO */}
<section className="hero-section">
  <iframe
    className="hero-video"
    src="https://www.youtube.com/embed/ia1RSrD662k?autoplay=1&mute=1&loop=1&playlist=ia1RSrD662k&controls=0&modestbranding=1"
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerPolicy="strict-origin-when-cross-origin"
    allowFullScreen
  />   
        <div className="hero-overlay">
          <div className="hero-badge">TESTIMONY</div>
          <h1>Pastor's Call to Ministry</h1>
          <p>Journey of faith, obedience, and divine assignment</p>
          <div className="hero-divider">
            <span className="divider-line"></span>
            <span className="divider-cross">✦</span>
            <span className="divider-line"></span>
          </div>
        </div>
      </section>

      {/* ================= READ CONTENT ================= */}
      <section className="read-content">
        <div className="content-wrapper">

          {/* Chapter 1 */}
          <article className="read-section">
            <div className="section-number">01</div>
            <div className="section-body">
              <h2>A voice to resign</h2>
              <div className="section-rule"></div>
              <p>
                As we moved on, this lady knelt down in the middle of the road and begged me to turn back to God. 
                I told her that I will and asked her to stand up since it was a way for vehicles. This act really shook me. 
                We parted ways, each taking a different route for home. Along the way, I realized something was not right 
                with me. I decided to go in my closet and find out what exactly God was saying. The following morning, 
                I never walked out. I started praying at 8am. After 30 minutes in prayer, God spoke to me, saying, 
                "I have been looking for you but it was so hard to get you. Go and resign from all responsibilities you are 
                having, I want to tell you many things." In one month, I had handed over all ministerial and leadership 
                responsibilities I held.
              </p>
            </div>
          </article>

          {/* Chapter 2 */}
          <article className="read-section alt">
            <div className="section-number">02</div>
            <div className="section-body">
              <h2>Into my prayer closet</h2>
              <div className="section-rule"></div>
              <p>
                I came back and focused on seeking God in prayer and fasting from 8am to 5pm daily.  
                God started showing me various things right from my personal life, being unclean. 
                I repented of it and God showed me how I had gone astray involving myself in ministries which 
                He neither told me nor I asking Him before joining. I had many cases to answer and repent for. 
                For close to three months of prayers, God appeared each day and pointed at my mistakes. 
                I afterwards found myself gain acceptance before God, Than God told me I know you come from Africa a 
                people who I never consistent, but I don't want you be like that, I told God, "I come from a poor country. 
                Black people who look like monkeys. Please bless us and change our skin look." And God accepted 
              </p>
            </div>
          </article>

          {/* Chapter 3 */}
          <article className="read-section">
            <div className="section-number">03</div>
            <div className="section-body">
              <h2>Forty two days in heaven </h2>
              <div className="section-rule"></div>
              <p>
                I was taken to heaven in spirit for 42 days, being shown so many things. 
                After that period, God told me that your period of studying heaven has ended, 
                go back on earth. I resisted and told Him, I don't want to go back because this is a good place to live in. 
                He told me, "don't be selfish, only wishing yourself good things." He also told me that, 
                "your place is not here but on earth. That is where you belong and where your work is." 
                I came back and I continued in prayer, God called me, one more time to heaven and told me to teach 
                His people how to give back to Him. He showed me the marriage being conducted on earth and said, 
                "you see the state of marriage on earth, all that isn`t mine." And He showed me how Jesus' generation was 
                exalted on earth, and said that He wasn`t part of it. Then He told me, "I have decided to start my own 
                generation on earth." He told me my responsibility and assigned me to go and put things right on earth.
              </p>
            </div>
          </article>

          {/* Chapter 4 */}
          <article className="read-section alt">
            <div className="section-number">04</div>
            <div className="section-body">
              <h2>Seven days underworld</h2>
              <div className="section-rule"></div>
              <p>
                Then God took me to the underworld for seven days. It was a really dark and scary place. 
                I saw Lucifer seated on his chair. Underneath his chair was a black cloth covering skulls of dead people. 
                Where he puts his feet was a red cloth. Lucifer being their master, the serpent, insects, animal, man, 
                woman, Jesus, birds among other creatures were in their positions. Just like people mourning at a vigil, 
                I heard spirits making noise from one department. I saw precious jewelry, makeups, perfumes, 
                among other adorning things that ladies apply on their bodies. I saw gold and silver being 
                controlled by lucifer.
              </p>
            </div>
          </article>

          {/* Chapter 5 */}
          <article className="read-section">
            <div className="section-number">05</div>
            <div className="section-body">
              <h2>False heaven </h2>
              <div className="section-rule"></div>
              <p>
                I was taken to the underworld heaven, therein, where Abraham stays. 
                It was an isolated, bushy and forested place. Abraham lived among animals. 
                I was taken to see the biblical god that Moses met, who told him that you can`t see my face and live. 
                The first point along the way to this territory was guarded by a woman. She strictly patrolled this road 
                second after second. Like in a skating wheel, she was moving to and fro. The second point was guarded by 
                the snake. It could rise from the soil into the space and back to the soil. Then this god came. 
                As he passed by, he was in a human nature. His clothes were very dirty and disgusting. Various insects were 
                on his body producing different noises which went on accompanying him.
              </p>
            </div>
          </article>

          {/* Chapter 6 */}
          <article className="read-section alt">
            <div className="section-number">06</div>
            <div className="section-body">
              <h2>Four years study on earth</h2>
              <div className="section-rule"></div>
              <h2 className="sub-heading">The first family </h2>
              <div className="section-rule"></div>
              <p>
                Later on, I was taken to a place where the first family lived on earth. 
                This was a peaceful place. Life was calm, good, simple, and everything could respond immediately. 
                The environment was just like what I experienced in heaven. I told God that I am not leaving this place 
                and He told me, "go back to your house, you will find there this atmosphere." When I went back, 
                home was filled with peace, joy, love and everything pertaining life was so good simplified. 
              </p>
            </div>
          </article>

          {/* Chapter 7 */}
          <article className="read-section">
            <div className="section-number">07</div>
            <div className="section-body">
              <h2>Horrible life </h2>
              <div className="section-rule"></div>
              <p>
                After seven days, this good experience was taken away and they brought me back to the real life 
                experiences that people face on earth. Family needs were calling for my attention but whatever was 
                asked for was pressing and could pierce my heart and disturb my mind as they demanded for finances. 
                The surrounding was filled with noise of children, sound systems etc. Then I yelled to God, 
                "What kind of life is this? Why have you taken away the good life?" And God responded saying "it's not yet time 
                to live in that life but you will get it sometime later."
                <br /><br />
                God showed me how world systems are made and governed. He showed me different Nations, 
                He showed continents like Africa, Asia, Europe, America, among others. He showed me lakes, forests, 
                mountains, religions, shrines, political leaders, high profile pastors, world bodies, etc. He also warned me, 
                "Never despise anything on earth, the world is filled with dangerous things that even the smallest 
                insect can bring a giant down."
              </p>
            </div>
          </article>

          {/* Chapter 8 */}
          <article className="read-section alt">
            <div className="section-number">08</div>
            <div className="section-body">
              <h2>God's promises for Uganda</h2>
              <div className="section-rule"></div>
              <p>
                God promised to bless Uganda, making it powerful and shining on the face of the world. 
                I saw Uganda raised above all countries in the world and shining. He promised to make Uganda number 
                one in the entire world. He said there will be no village or poor person in Uganda. He promised to boost 
                Farming, Tourism, developing new mineral sites of gold and adding more on the already existing minerals. 
                Increasing more oil wells to the already existing wells. Manufacturing cars. Associations that bring people 
                together with a mind of development will be formed. He will grant Ugandans rare knowledge, 
                they will be highly intelligent to advance Technology and Innovation. He said that Ugandans will be taken 
                abroad to work as expatriates. He also said that nations will be flocking into Uganda, He said Uganda will 
                the heart of the world and turning point for the world.
                During this period I never moved even to the veranda, never shaved my hair, communicated on phone with 
                anyone. I never moved anywhere. That was from 2010 until 2014.
              </p>
            </div>
          </article>

          {/* Chapter 9 */}
          <article className="read-section">
            <div className="section-number">09</div>
            <div className="section-body">
              <h2>Out of the closet</h2>
              <div className="section-rule"></div>
              <p>
                In 2014 God told me to walk out of the house to the veranda and shave my hair because I hadn't shaved 
                for all those years. He told me to start communicating on phone. Later on, He told me to hold a retreat 
                and tell people what God is speaking. I successfully held one in a school and shared what God told me. 
                I also started a fellowship at home and people having different issues could come for prayers. 
                We held another retreat in a school and it was massively attended. Devil worshippers, those who were 
                Lucifer`s strong pillars came. God delivered them and they shared all about Lucifer, underworld 
                systems and there members, how they operate in churches, schools, hospitals, factories, telecom companies, 
                and how they control this world. 
                We prayed, attacking Lucifer and its kingdom and so many things manifested, all of which are not detailed 
                here. God journeyed us to having a strong fellowship at home, organizing ministers with the vision of 
                God and the singing team with new songs from God. 
              </p>
            </div>
          </article>

          {/* Chapter 10 */}
          <article className="read-section alt">
            <div className="section-number">10</div>
            <div className="section-body">
              <h2>Start of the church &amp; Lucifer's threats</h2>
              <div className="section-rule"></div>
              <p>
                In 2018, God told me to start a church and showed me where to establish it. 
                We started the church in the tent while renting the ground, Lucifer started coming, 
                challenging me that, "you are on space, any time I will chase you away from this place." 
                I presented these threats of lucifer to God and God told me that, "you cannot change what isn't yours to be 
                yours.". 
              </p>
            </div>
          </article>

          {/* Chapter 11 */}
          <article className="read-section">
            <div className="section-number">11</div>
            <div className="section-body">
              <h2>Purchase of church land</h2>
              <div className="section-rule"></div>
              <p>
                Later on, the owner of the land came and told me to buy part of his plot and God enabled us to pay for it. 
                After some time, he brought all documents of the remaining land and the house on it, saying give me the money. 
                We agreed, paid and cleared him. From there, we managed to own the place without any more threats from lucifer. 
                God went on revealing many things. We handled and have gone on dealing with strong holds controlling the earth 
                in the move of bringing back the earth into God's control.
              </p>
            </div>
          </article>

          {/* End ornament */}
          <div className="cta-wrapper">
            <div className="cta-ornament">✦ ✦ ✦</div>
            <p className="cta-subtext">To God be the glory</p>
          </div>

        </div>
      </section>

      {/* ================= INTERNAL CSS ================= */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400&family=Cinzel:wght@400;600;700&family=EB+Garamond:ital,wght@0,400;0,500;1,400&display=swap');

        :root {
          --navy: #0a1628;
          --navy-mid: #122040;
          --gold: #c9a84c;
          --gold-light: #e8c96a;
          --cream: #f5f0e8;
          --text: #2a2018;
          --text-light: #5a4e3a;
        }

        /* ---- HERO ---- */
               .hero-section {
  position: relative;
  width: 100%;
  height: 100vh; /* full viewport height */
  overflow: hidden;
}

.hero-video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transform: translate(-50%, -50%);
  object-fit: cover; /* makes video cover the section */
  filter: brightness(0.45) saturate(0.7); /* optional dark/filter effect */
  pointer-events: none; /* so it doesn’t capture clicks */
}
        .hero-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          color: #fff;
          padding: 20px;
          background: linear-gradient(
            to bottom,
            rgba(10,22,40,0.3) 0%,
            rgba(10,22,40,0.55) 60%,
            rgba(10,22,40,0.85) 100%
          );
        }
        .hero-badge {
          font-family: 'Cinzel', serif;
          font-size: 0.7rem;
          letter-spacing: 0.4em;
          color: var(--gold);
          border: 1px solid var(--gold);
          padding: 6px 20px;
          margin-bottom: 28px;
          text-transform: uppercase;
          animation: fadeUp 1s ease both;
        }
        .hero-overlay h1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.6rem, 6vw, 5.5rem);
          font-weight: 300;
          letter-spacing: 0.04em;
          line-height: 1.1;
          color: #fff;
          margin: 0 0 16px;
          animation: fadeUp 1s 0.2s ease both;
          text-shadow: 0 2px 30px rgba(0,0,0,0.5);
        }
        .hero-overlay p {
          font-family: 'EB Garamond', serif;
          font-style: italic;
          font-size: clamp(1rem, 2vw, 1.3rem);
          color: rgba(255,255,255,0.8);
          margin: 0 0 32px;
          animation: fadeUp 1s 0.4s ease both;
        }
        .hero-divider {
          display: flex;
          align-items: center;
          gap: 14px;
          animation: fadeUp 1s 0.6s ease both;
        }
        .divider-line {
          display: block;
          width: 80px;
          height: 1px;
          background: var(--gold);
          opacity: 0.7;
        }
        .divider-cross {
          color: var(--gold);
          font-size: 0.9rem;
        }

        /* ---- BODY ---- */
        .read-content {
          background: var(--cream);
          background-image:
            radial-gradient(ellipse at 20% 0%, rgba(201,168,76,0.06) 0%, transparent 60%),
            radial-gradient(ellipse at 80% 100%, rgba(10,22,40,0.05) 0%, transparent 60%);
          font-family: 'EB Garamond', serif;
          color: var(--text);
          padding: 80px 0 60px;
        }

        .content-wrapper {
          max-width: 820px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* ---- SECTIONS ---- */
        .read-section {
          display: grid;
          grid-template-columns: 56px 1fr;
          gap: 32px;
          margin-bottom: 64px;
          padding-bottom: 64px;
          border-bottom: 1px solid rgba(201,168,76,0.2);
          animation: fadeUp 0.7s ease both;
        }
        .read-section:last-of-type {
          border-bottom: none;
        }
        .read-section.alt {
          background: linear-gradient(135deg, rgba(10,22,40,0.03) 0%, transparent 100%);
          border-radius: 2px;
          padding: 32px 32px 32px 0;
          margin-left: -8px;
          padding-left: 8px;
        }

        .section-number {
          font-family: 'Cinzel', serif;
          font-size: 0.68rem;
          font-weight: 700;
          letter-spacing: 0.15em;
          color: var(--gold);
          opacity: 0.8;
          align-self: start;
          padding-top: 6px;
        }

        .section-body {
          min-width: 0;
        }

        .section-body h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(1.6rem, 3.5vw, 2.3rem);
          font-weight: 600;
          color: var(--navy);
          margin: 0 0 12px;
          line-height: 1.2;
          letter-spacing: 0.01em;
        }

        .section-body h2.sub-heading {
          font-size: clamp(1.2rem, 2.5vw, 1.7rem);
          margin-top: 32px;
          color: var(--navy-mid);
        }

        .section-rule {
          width: 48px;
          height: 2px;
          background: linear-gradient(90deg, var(--gold), transparent);
          margin-bottom: 20px;
        }

        .section-body p {
          font-size: 1.1rem;
          line-height: 1.95;
          color: var(--text);
          margin: 0;
          font-weight: 400;
        }

        /* ---- CTA ---- */
        .cta-wrapper {
          text-align: center;
          padding: 60px 0 20px;
        }
        .cta-ornament {
          font-size: 0.8rem;
          color: var(--gold);
          letter-spacing: 0.5em;
          margin-bottom: 16px;
          opacity: 0.8;
        }
        .cta-subtext {
          font-family: 'Cormorant Garamond', serif;
          font-style: italic;
          font-size: 1.3rem;
          color: var(--text-light);
          margin-bottom: 0;
        }

        /* ---- ANIMATIONS ---- */
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ---- RESPONSIVE ---- */
        @media (max-width: 600px) {
          .read-section {
            grid-template-columns: 1fr;
            gap: 8px;
          }
          .section-number {
            font-size: 0.6rem;
            padding-top: 0;
          }
          .read-section.alt {
            padding: 24px 16px;
            margin-left: 0;
          }
          .hero-overlay h1 {
            font-size: 2.2rem;
          }
          .divider-line {
            width: 40px;
          }
        }
      `}</style>
    </>
  );
};

export default Read;
